import { render, staticRenderFns } from "./SupportTicket.vue?vue&type=template&id=cf19655a&scoped=true&"
import script from "./SupportTicket.vue?vue&type=script&lang=js&"
export * from "./SupportTicket.vue?vue&type=script&lang=js&"
import style0 from "./SupportTicket.vue?vue&type=style&index=0&id=cf19655a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf19655a",
  null
  
)

export default component.exports